/**
 * Environment Configuration
 * Centralized access to environment variables
 */

export const ENV = {
  // Google Analytics
  GA_MEASUREMENT_ID: import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-CJFBGG02DL',
  
  // Google AdSense
  ADSENSE_CLIENT_ID: import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-8241230112815576',
  
  // Site URL
  SITE_URL: import.meta.env.VITE_SITE_URL || 'https://svg-2-code.netlify.app',
  
  // App Info
  APP_NAME: import.meta.env.VITE_APP_NAME || 'ImageLab',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.1',
  
  // Environment
  IS_PRODUCTION: import.meta.env.PROD,
  IS_DEVELOPMENT: import.meta.env.DEV,
} as const;

// Type for environment config
export type EnvConfig = typeof ENV;
